import InputGroup from "react-bootstrap/InputGroup"
import { useDispatch, useSelector } from "react-redux"
import { teamStatus } from "state_management"
import Form from "react-bootstrap/Form"
import useT from "utils/hooks/useT"

export default function IncludeOverdueButton() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const includeOverdue = useSelector((state) => state.teamStatus.includeOverdue)
  return (
    <InputGroup>
      <Form.Check
        checked={includeOverdue}
        type={"checkbox"}
        id={`include-overdue-checkbox`}
        onChange={(e) => dispatch(teamStatus.includeOverdue({ includeOverdue: e.target.checked }))}
      />
      <div className="Include-today">
        <p>{t("includeOverdue")}</p>
      </div>
    </InputGroup>
  )
}
